var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ez-user-list',{attrs:{"users":_vm.users,"headers":{
    email: () => 'Email Address'
  },"columns":['name', 'email', 'role'],"columnProps":{
    role: { class: 'role-cell' },
  }},on:{"userClick":_vm.onUserClick,"addUser":_vm.onAddUser,"removeUser":_vm.onRemoveUser}},[_c('ez-distributor-user-modal',{ref:"userModal",attrs:{"roles":_vm.roles,"formKey":_vm.formKey,"distributorId":_vm.distributorId,"userId":_vm.selectedUserId,"selected-user":_vm.selectedUser},on:{"submitSuccess":_vm.onSubmitSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }